// extracted by mini-css-extract-plugin
export default {"addicionalCharge":"AddAdditionalCharge_addicionalCharge__YbBQ2","campos":"AddAdditionalCharge_campos__jmdxC","botao":"AddAdditionalCharge_botao__vwnXM"};